
export const cargarDocs = async (documentos, inscripcionid) => { 
  let baseurl = process.env.VUE_APP_URL_DOCUMENTOS+'/inscripciones-documentos-personas/inscripciones';
  let URL = baseurl+'/'+inscripcionid
  let tam = 0;
  const formdata = new FormData();

  window.console.log('env', process.env);

  documentos.forEach((d,i) => {
    d.tipoDocumentoPersona.plantillaDatos.forEach((p,j) => {  
      // if(p.archivo){
        tam += 1;
        formdata.append(`documentosPersonas[${i+j}][tipoDocumentoPersonaId]`, d.tipoDocumentoPersonaId);
        formdata.append(`documentosPersonas[${i+j}][datos][${i+j}][id]`, p.id);
        formdata.append(`documentosPersonas[${i+j}][datos][${i+j}][nombre]`, p.nombre);
        formdata.append(`documentosPersonas[${i+j}][datos][${i+j}][tipo]`, p.tipo);
        formdata.append(`documentosPersonas[${i+j}][datos][${i+j}][etiqueta]`, p.etiqueta);
        formdata.append(`documentosPersonas[${i+j}][datos][${i+j}][valor]`, p.valor); 
        // formdata.append(`archivos[${i+j}]`, p.archivo, p.archivo.name);
        // formdata.append(`archivo`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
        // formdata.append(`documentosPersonas[${i+j}][archivos][${i+j}]`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
        // formdata.append(`documentosPersonas[${i+j}][archivos][${i+j}]`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
        // formdata.append(`documentosPersonas[${i+j}][archivos][${i+j}]`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
        // } 
    })
    // formdata.append(`documentosPersonas[${i}][archivos][${i}]`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
  });
  documentos.forEach((d,i) => {
    formdata.append(`[archivos][${i}]`, d.tipoDocumentoPersona.archivo, d.tipoDocumentoPersona.archivo.name);
  })

  /* for (const pair of formdata.entries()) {
    window.console.log('---',`${pair[0]}: ${pair[1]}`);
  } */

  if(tam == 0){
    return null;
  }

  const requestOptions = {
    method: "POST",
    body: formdata, 
  };

  let response  = await fetch(URL, requestOptions)
  let res = await response.json();

  window.console.log('cargarDocs, resss', res);
  return res;
}

export const actualizarDatos = async (docPersona,plantilla,inscripcionid) => {
  window.console.log('>>>>',docPersona,plantilla, inscripcionid,plantilla.archivo);
  const formdata = new FormData();
  formdata.append("documentoPersona[tipoDocumentoPersonaId]", docPersona.tipoDocumentoPersonaId);
  formdata.append("documentoPersona[datos][0][id]", plantilla.id);
  formdata.append("documentoPersona[datos][0][nombre]", plantilla.nombre);
  formdata.append("documentoPersona[datos][0][tipo]", plantilla.tipo);
  formdata.append("documentoPersona[datos][0][etiqueta]", plantilla.etiqueta);
  formdata.append("documentoPersona[datos][0][valor]", plantilla.valor);
  formdata.append("archivo", plantilla.archivo, plantilla.archivo.name);

  let baseurl = process.env.VUE_APP_URL_DOCUMENTOS+'/inscripciones-documentos-personas/';
  let URL = baseurl+inscripcionid 

  const requestOptions = {
    method: "POST",
    body: formdata, 
  };

  let response  = await fetch(URL, requestOptions)
  let res = await response.json();
  window.console.log('actualizarDocs, resss', res);
  return res;
}